import styled, { keyframes } from "styled-components";
import { Link } from "react-router-dom";
import { BOX_SHADOW, DARKER, PRIMARY, SECONDARY } from "../../const/colors";
import { ButtonSpecial } from "../../components/common/ButtonSpecial";
import { ReactComponent as GiftIconSolid } from "../../assets/icons/gift-solid.svg";
import { ReactComponent as UserIconOutlined } from "../../assets/icons/person.svg";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { ReactComponent as CreditCardIcon } from "../../assets/icons/credit-card.svg";
import { mobile_normal } from "../../const/fonts";

export const Container = styled.header.attrs((props) => ({
  className: props.className,
}))`
  min-width: 100vw;
  max-width: 100vw;
  height: auto;
  max-height: max-content;
  position: relative;
  border-bottom: 12px solid ${PRIMARY};
  padding-top: 2px;
  .wrap {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  transition: all 0.3s ease;

  @media screen and (max-width: 1080px) {
    position: absolute;
    width: 100%;
    top: 0;
    right: 0;
    border: none;
    padding: 0;

    position: fixed;
    z-index: 2003;

    &.sticky {
      background-color: ${SECONDARY};
    }
  }
`;

export const Nav = styled.nav.attrs((props) => ({
  className: props.className,
}))`
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 2200px;
  > a {
    z-index: 2002;
    height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    //altura navidad
    //height: 90px;
  }

  @media screen and (max-width: 2200px) {
    margin: 0;
  }

  @media screen and (max-width: 1300px) {
    > a {
      //altura normal
      height: 60px;

      //altura navidad
      //height: 70px;
    }
  }

  @media screen and (max-width: 1800px) {
    > a {
      //altura normal
      height: 60px;
      display: flex;
      margin-right:5px;
      //altura navidad
      //height: 70px;
    }
  }

  @media screen and (max-width: 1080px) {
    width: 100%;
    justify-content: space-between;
    padding: 0 2%;
    //z-index: 2000;
  }

  @media screen and (max-width: 756px) {
    > a {
        height: 52px;
        margin-right: 0px;
        justify-content: start;
        align-items: center;
        width: 100%;
        margin-top: 11px;
      }
  }
`;
export const Logo = styled.img`
  //altura normal
  height: 100px;
  max-height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;

  //altura navidad
  //height: 80px;
  //max-height: 80px;
  //margin-right: 1rem;
  //

  @media screen and (max-width: 1800px) {
    height: auto;
    width: 200px;
    //z-index: 1001;
  }
  @media screen and (max-width: 1600px) {
    width: 180px;
  }
  @media screen and (max-width: 1380px) {
    width: 150px;
  }
  @media screen and (max-width: 1080px) {
    position: fixed;
    width: 200px;
    left: 69px;
    top: 20px;
    a {
      height: 50px;
    }
  }
  @media screen and (max-width: 768px) {
    position:relative;
    width: 175px;
    left: 0;
    top: 0;
    margin-left: 0;
  }
  @media screen and (max-width: 500px){
    &.minilogo{
      width: 60px;
      left: 0px;
      top: 0px;
      margin:0px;
    }
  }
`;

export const NavSection = styled.ul.attrs((props) => ({
  className: props.className,
}))`
  display: flex;
  align-items: center;
  list-style: none;
  height: auto;
  transition: all 0.3s ease;

  @media screen and (max-width: 1400px) {
    //margin por altura de logo navidad
    //margin-top: 0.5rem;
  }

  @media screen and (max-width: 1200px) {
    padding-right: 0;
  }
  @media screen and (max-width: 1080px) {
    position: absolute;
    top: -700px;
    left: -2000px;
    margin: 0 auto;
    text-align: center;

    &.active {
      width: 100%;
      height: 100vh;
      display: block;
      top: 0;
      left: 0;
      right: 0;
      text-align: left;
      z-index: 2001;
      padding: 6% 0;
      background-color: ${SECONDARY};
    }
  }
  @media screen and (max-width: 768px) {
    position: absolute;
    top: -700px;
    left: -2000px;
    margin: 0 auto;
    text-align: center;

    &.active {
      width: 100%;
      height: 100vh;
      display: block;
      top: 0;
      left: 0;
      right: 0;
      text-align: left;
      padding: 10%;
      //padding-top: 10vh;
      // cambiar a 10vh cuando se tenga version movil de spaceman
      padding-top: 15vh;
      background-color: ${SECONDARY};
    }
  }
`;

const resize = keyframes`
  0% {
    transform: scale(1);
  }
  60% {
    transform: scale(1.3);
  }
  80% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
`;

const floating = keyframes`
  0% { transform: translate(0,  -2px); }
  50%  { transform: translate(5px, -12px); }
  100%   { transform: translate(0, -2px); }
`;

export const NavItem = styled.li.attrs((props) => ({
  className: props.className,
}))`
  font-weight: bold;
  margin: 0 0.8rem;
  transition: background-color 0.3s;
  position: relative;
  overflow: hidden;
  z-index: 1;
  display: flex;
  height: 40px;
  &.btn-1:before {
    content: "";
    position: absolute;
    top: 0;
    right: -50px;
    bottom: 0;
    left: 0;
    border-right: 20px solid transparent;
    border-bottom: 40px solid ${PRIMARY};
    transform: translateX(-100%);
    box-sizing: border-box;
    transition: 0.5s ease-in-out;
    z-index: -1;
  }
  &.btn-1:hover {
    border:1px solid ${PRIMARY};
    > a {
      color: ${SECONDARY};
    }
  }
  &.btn-1:hover:before {
    transform: translateX(0);
  }
  &:hover svg > path , &:hover span.linkmenu, &:hover svg > g path{
    fill:${DARKER}!important;
    color:${DARKER};
  }
  .content_spaceman {
    position: absolute;
    transform: rotate(20deg);
    top: -15px;
    right: -12px;
  }
  .badge {
    display: inline-block;
    background-color: ${PRIMARY};
    border-radius: 0.5rem;
    color: ${DARKER};
    padding: 0.2rem 0.3rem;
    position: relative;
    font-size: 8px;
    animation: ${resize} 1s ease infinite;
    box-shadow: ${BOX_SHADOW};
  }

  .fly {
    animation-name: ${floating};
    animation-duration: 3s;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
  }

  span {
    font-size: 1rem;
    letter-spacing: 1.42px;
    position: relative;
    white-space: nowrap;

    &::after {
      content: "";
      height: 2px;
      background: linear-gradient(to right, rgba(0, 0, 0, 0.1), ${PRIMARY});
      position: absolute;
      left: 0;
      right: 0;
      bottom: -6px;
      opacity: 0;
      transform-origin: left center;
      transition: all 0.25s cubic-bezier(0.25, 0.43, 0.45, 0.94) 0s;
      transform: scaleX(0);
    }
  }
  
  @media screen and (max-width: 2000px) {
    span {
      font-size: 0.75rem;
    }
  }
  @media screen and (max-width: 1700px) {
    &.loged {
      margin: 0rem;
      margin-left: 0.5rem;
      margin-right: 0.5rem;
      span {
        font-size: 0.6rem;
      }
    }
  }
  @media screen and (max-width: 1800px) {
    margin: 0rem;
    margin-left: 0.0rem;
    margin-right: 0.0rem;
    padding: 0 0.5rem;
    span {
      font-size: 0.7rem;
    }
    &.loged {
      margin: 0 0.35rem;
    }
  }
  @media screen and (max-width: 1400px) {
    margin: 0 0rem;
    padding: 0 0.3rem;
    span {
      letter-spacing: 0px;
    }
    &.loged {
      margin: 0 0.25rem;
    }

    .content_spaceman {
      transform: rotate(20deg);
      top: -15px;
      right: -10px;
      .badge {
        padding: 0.2rem;
      }
    }
  }
  @media screen and (max-width: 1300px) {
    span {
      font-size: 0.6rem;
    }
  }
  @media screen and (max-width: 1200px) {
    margin: 0 0.3rem;
    &.loged {
      margin: 0rem;
      span {
        font-size: 0.6rem;
      }
    }
    span {
      font-size: 0.6rem;
    }
  }

  @media screen and (max-width: 1080px) {
    border-bottom: 1px solid ${DARKER};
    padding: 0 5%;
    /* descomentar cuando se tenga version movil de spaceman*/
    /*&.spacemanDesk {
      display: none;
    }*/

    &.loged span,
    span {
      font-size: 1rem;
      line-height: 3.5;
    }
    &:hover {
      span::after {
        transform: none;
        opacity: 0;
      }
    }

    /** eliminar cuando se tenga version movil de spaceman */
    .content_spaceman {
      transform: rotate(0deg);
      top: 10px;
      right: 20px;
    }
  }
  @media screen and (max-width: 768px) {
    border-bottom: 1px solid ${DARKER};
    padding: 0;
    &.loged span,
    span {
      font-size: ${mobile_normal};
      line-height: 3.5;
    }
    &:hover {
      span::after {
        transform: none;
        opacity: 0;
      }
    }
  }
`;
export const StyledLink = styled(Link)`
  transition: all .5s ease 0s;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  & span{
    display: inline-block;
    position: relative;
    // transition: all .5s ease;
    line-height:2;
  }

  > img {
    width: 28px;
    height: 28px;
    margin-right:5px;
  }

  .icon-promotion {
    display: none;
  }
  &:hover {
    // transition: color 0.25s cubic-bezier(0.25, 0.43, 0.45, 0.94) 0s;
    color: #ffffe6;
  }
  @media screen and (max-width: 1800px) {
    > svg {
      font-size: 16px;
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
  }
  @media screen and (max-width: 1080px) {
    .icon-promotion {
      display: inline;
    }

    > svg {
      font-size: 21px;
      width: 21px;
      height: 21px;
      margin-right: 15px;
    }

    > img {
      width: 21px;
      height: 21px;
      margin-right: 15px;
    }
  }
  @media screen and (max-width: 600px) {
    width:100%;
  }
`;

export const LangContainer = styled.div`
  @media screen and (max-width: 1800px) {
    img {
      width: 20px;
    }
  }

  @media screen and (max-width: 1400px) {
    .MuiButton-endIcon {
      margin-left: 5px;
    }
  }

  @media screen and (max-width: 1080px) {
    display: none;
  }
`;

export const ButtonSpecial2 = styled(ButtonSpecial).attrs((props) => ({
  className: props.className,
}))`
  background-color: ${(props) =>
    props.bg === "primary" ? PRIMARY : "transparent"};
  color: ${(props) => (props.bg === "primary" ? SECONDARY : PRIMARY)};
  border: 1px solid ${PRIMARY};
  font-size: 1rem;
  padding: 0.6rem;
  font-weight: 600;
  margin-left: ${(props) => (props.bg === "primary" ? 0 : "1rem")};
  min-width: fit-content;

  @media screen and (max-width: 2000px) {
    font-size: 0.8rem;
    &.loged {
      padding: 0.8rem 0.9rem;
    }
  }
  @media screen and (max-width: 1500px) {
    font-size: 0.7rem;
    &.loged {
      padding: 0.8rem 1rem;
    }
  }
  @media screen and (max-width: 1400px) {
    &.loged {
      padding: 0.7rem 0.5rem;
    }
  }
  @media screen and (max-width: 1300px) {
    span {
      font-size: 0.6rem;
    }
  }
  @media screen and (max-width: 1800px) {
    &.loged {
      margin-left: ${(props) => (props.bg === "primary" ? 0 : "0.5rem")};
      padding: 0.5rem;
    }
  }
  @media screen and (max-width: 1200px) {
    padding: 0.5rem 0.3rem;
    font-size: 0.6rem;
    &.loged {
      padding: 0.5rem 0.2rem;
    }
  }
  @media screen and (max-width: 1080px) {
    width: 45%;
    font-size: 1rem;
    padding: 0.8rem 1.2rem;
  }
  @media screen and (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

export const ButtonWallet = styled.div.attrs((props) => ({
  className: props.className,
}))`
  font-size: 1rem;
  padding: 0.68rem 0.5rem;
  font-weight: bold;
  margin-left: 1rem;
  box-shadow: ${BOX_SHADOW};
  color: #fff;
  border: 1px solid ${PRIMARY};
  > span {
    display: flex;
    align-items: center;
    cursor: default;
    svg {
      font-size: 18px;
      margin-right: 3px;
    }
    > span {
      white-space: nowrap;
      width: calc(100%);
    }
  }

  @media screen and (max-width: 2000px) {
    font-size: 0.8rem;
  }

  @media screen and (max-width: 1400px) {
    padding: 0.5rem 0.5rem;
  }

  @media screen and (max-width: 1800px) {
    margin-left: 0.5rem;
    padding: 0.37rem 0.5rem;
  }

  @media screen and (max-width: 1500px) {
    padding: 0.32rem 0.5rem;
    font-size: 0.7rem;
  }

  @media screen and (max-width: 1200px) {
    font-size: 0.6rem;
    padding: 0.285rem 0.2rem;
  }
`;

export const UserMenuContainer = styled.div`
  position: relative;

  margin-left: 1rem;
  @media screen and (max-width: 1200px) {
    margin-left: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
`;
const glow = keyframes`
	from {
		stroke: ${PRIMARY};
		// filter: drop-shadow(0px 0px 0px rgb(0 0 0 / 0.4));
  }
  to {
		stroke: ${PRIMARY};
		// filter: drop-shadow(0px 0px 20px rgb(255 255 255 / 0.4));
  }
`;
const shrink = keyframes`
	from {
		transform: scale(1);
  }
  to {
		transform: scale(1.10);
  }
`;
const shake = keyframes`
  from {
    transform: rotate(10deg);
  } to {
    transform: rotate(-10deg);
    transform-origin: center center;
  }
`;
const move = keyframes`
  from {
    transform: translateY(0px);
  } to {
    transform: translateY(-5px);
    transform-origin: center center;
  }
`;

const wobble = keyframes`
  0%,
  100% {
    transform: translateX(0%);
    transform-origin: 50% 50%;
  }
  15% {
    transform: translateX(-10px) rotate(6deg);
  }
  30% {
    transform: translateX(5px) rotate(-6deg);
  }
  45% {
    transform: translateX(-5px) rotate(3.6deg);
  }
  60% {
    transform: translateX(2px) rotate(-2.4deg);
  }
  75% {
    transform: translateX(-2px) rotate(1.2deg);
  }
`;

const pulsate = keyframes`

  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }

`;

export const UserIcon = styled(AccountCircleIcon).attrs((props) => ({
  className: props.className,
}))`
  color: ${PRIMARY};
  font-size: 32px !important;
  width: 25px;
  height: 25px;
  margin-right: 10px;
  transition: transform 350ms cubic-bezier(0.8, 0.5, 0.2, 1.4);
  cursor: pointer;
  &:hover {
    transform: scale(1.1);
  }

  @media screen and (max-width: 1800px) {
    width: 21px;
    height: 21px;
  }
  @media screen and (max-width: 1200px) {
    width: 19px;
    height: 19px;
    margin-right: 0.5rem;
  }
  @media screen and (max-width: 1080px) {
    width: 25px;
    height: 25px;
    &.glow {
      //animation: ${pulsate} 0.5s ease-in-out infinite both;
      //animation: ${wobble} 0.8s 0.5s infinite both;
      animation: ${shrink} 1s ease-in-out infinite alternate;
      path,
      circle {
        animation: ${glow} 1s ease-in-out infinite alternate;
      }
    }
  }
`;

export const IconsMobile = styled.div`
  display: none;
  @media screen and (max-width: 1080px) {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    margin: 10px 7px 0px;
    padding-top: 0;
    z-index: 2002;
  }
`;

export const SocialMediaContainer = styled.div`
  display: none;
  @media screen and (max-width: 1080px) {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    margin-top: 1rem;
    margin-bottom: auto;
    padding: 0 5%;
    margin-bottom: 1rem;
    div.btns {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;
    margin-top: 4rem;
    margin-bottom: auto;
    padding: 0;
    div.btns {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 1rem;
    }
  }
  @media screen and (max-width: 375px) {
    margin-top: 1rem;
  }
`;
export const GiftIcon = styled(GiftIconSolid)`
  width: 28px;
  height: 28px;
  font-size: 28px;
  transition: color 0.3s ease-in;

  transition: transform 350ms cubic-bezier(0.8, 0.5, 0.2, 1.4);
  cursor: pointer;
  &:hover {
    transform: scale(1.1);
    transition: 350ms cubic-bezier(0.8, 0.5, 0.2, 1.4);
  }

  @media screen and (max-width: 1500px) {
    width: 25px;
    height: 25px;
  }
  @media screen and (max-width: 1080px) {
    width: 21px;
    height: 21px;
    font-size: 21px;
    margin-bottom: 5px;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  position: relative;
  margin-left: 1rem;
  @media screen and (max-width: 1080px) {
    display: none;
  }
`;

export const CreditCard = styled(CreditCardIcon)`
  margin-right: 5px;
  path {
    stroke: #000;
    fill: #000;
  }
`;

export const UserIconContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: space-betweens;
  align-items: center;

  // span {
  //   position: absolute;
  //   bottom: 5px;
  //   left: 18px;
  //   width: 7px;
  //   height: 7px;
  //   border-radius: 50%;
  //   background-color: red;
  // }
  span.new {
    position: absolute;
    top: 5px;
    left: 0px;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: red;
  }
  img{
    width: 100%;
    max-width: 52px;
    min-width: 52px;
    min-height: 50px;
    max-height: 52px;
    border-radius: 50%;
    cursor:pointer;
  }
  @media screen and (max-width: 1080px) {
    span {
      right: 3px;
    }
    img{
      width: 100%;
      max-width: 60px;
      min-width: 52px;
      min-height: 50px;
      max-height: 52px;
      border-radius: 50%;
      margin-right: 15px;
    }
  }
`;

export const FeaturedContainer = styled.li`
  display: none;
  gap: 10px;

  border-bottom: 1px solid ${PRIMARY};

  @media screen and (max-width: 1080px) {
    display: flex;
    justify-content: center;
  }

  @media screen and (max-width: 600px) {
    justify-content: space-between;
  }
`;

export const FeaturedCard = styled.div`
  width: 150px;
  margin-bottom: 1rem;
  height: 70px;
  object-fit: cover;
  overflow: hidden;
  //border-radius: 1rem;
  box-shadow: 0px 0px 14px #000;
`;

export const FeaturedImg = styled.img`
  width: 100%;
  height: 100%;
`;

export const LogoContainer = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
`;
